module.exports = __webpack_public_path__ + "img/4_72.5ccca853.png";